import { render } from "./chart.vue?vue&type=template&id=0ccc4d59&scoped=true"
const script = {}

import "./chart.vue?vue&type=style&index=0&id=0ccc4d59&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccc4d59"]])

export default __exports__